import actions from './actions';
import initialState from '../initialState';

export const watchlistReducer = (state = initialState.watchlists, action) => {
    switch (action.type) {
        case actions.WATCHLIST_LOAN_DETAIL_MODAL:
            return {
                ...state,
                watchlistLoanDetailModal: action.state.watchlistLoanDetailModal,
            };
        case actions.WATCHLIST_ADD_LOAN_MODAL:
            return {
                ...state,
                watchlistAddLoanModal: action.state.watchlistAddLoanModal,
            };
        case actions.GROUP_ITEMS_MODAL:
            return { ...state, groupItemsModal: action.state.groupItemsModal };
        default:
            return { ...state };
    }
};

export default watchlistReducer;
